<div class="backdrop" *ngIf="showDialog" (click)="onClose()">
  <div class="dialog" (click)="$event.stopPropagation()">
    <header class="dialog-header">
      <div *ngIf="!messageSent">
        <h3>{{ headerTitle }}</h3>
        <p *ngIf="subHeaderTitle">{{ subHeaderTitle }}</p>
      </div>

      <button
        class="close-btn"
        (click)="onClose()"
        aria-label="Close dialog"
        type="button"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect width="24" height="24" rx="12" fill="#E5E5E5" />
          <path
            d="M12 10.8891L15.8891 7L17 8.11094L13.1109 12L17 15.8891L15.8891 17L12 13.1109L8.11094 17L7 15.8891L10.8891 12L7 8.11094L8.11094 7L12 10.8891Z"
            fill="black"
          />
        </svg>
      </button>
    </header>

    <ng-container *ngIf="!messageSent; else successMessage">
      <section class="dialog-body">
        <div *ngIf="['SMS', 'EMAIL'].includes(element.question.type)">
          <label class="label" [for]="'contact-input-' + element.id">
            {{ questionElement.label[language] }}
          </label>
          <select
            [(ngModel)]="defaultValue"
            [disabled]="contacts.length === 0 || isLoadingContact"
          >
            <option
              *ngFor="let contact of contacts"
              [value]="contact.contactId"
            >
              {{ contact.contactText }}
            </option>
          </select>
          <p class="helper-text" *ngIf="showUnsubscribedHelperText">
            {{ unsubscribedHelperTextKey | translate }}
          </p>
        </div>
      </section>

      <footer class="dialog-footer">
        <button class="btn btn-secondary" (click)="onClose()" type="button">
          {{ "surveys.dialog.close" | translate }}
        </button>
        <button
          class="btn btn-primary"
          [class.btn-disabled]="!defaultValue || isLoading"
          [disabled]="!defaultValue || isLoading"
          (click)="onConfirm()"
          type="button"
        >
          {{ "surveys.dialog.send" | translate }}
        </button>
      </footer>
    </ng-container>

    <ng-template #successMessage>
      <section class="dialog-body-message">
        <p class="label" aria-label="Success">✅</p>
        <p class="dialog-message">
          {{ "surveys.dialog.messageSent" | translate }}
        </p>
      </section>

      <footer class="dialog-footer">
        <button class="btn btn-secondary" (click)="onClose()" type="button">
          {{ "surveys.dialog.close" | translate }}
        </button>
      </footer>
    </ng-template>
  </div>
</div>
